import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import thunk from 'redux-thunk';
import loaderSlice from './loader/loaderSlice';
import gallerySlice from '../pages/academyPage/gallery/gallerySlice'
import { galleryApi } from '../pages/academyPage/gallery/galleryApiSlice'
import knowledgePartnerSlice from '../pages/academyPage/knowledgePartner/knowledgePartnerSlice';
import { knowledgePartnerApi } from '../pages/academyPage/knowledgePartner/knowledgePartnerApiSlice';
import magazineSlice from '../pages/publicationPage/magazine/magazineSlice';
import { magazineApi } from '../pages/publicationPage/magazine/magazineApiSlice';
import eBookSlice from '../pages/publicationPage/eBooks/eBookSlice';
import { eBookApi } from '../pages/publicationPage/eBooks/eBookApiSlice'; 
import visitUsSlice from '../pages/visitUsPage/visitUsSlice';
import { visitUsApi } from '../pages/visitUsPage/visitUsApiSlice';
import homePageSlice from '../pages/homePage/homePageSlice'
import { homePageApi } from '../pages/homePage/homePageApiSlice';
import notificationSlice from '../pages/notificationPage/notificationSlice'
import { notificationApi } from '../pages/notificationPage/notificationApiSlice';
import trainingCalendarSlice from '../pages/trainingPage/trainingCalendar/trainingCalendarSlice';
import { trainingCalendarApi } from '../pages/trainingPage/trainingCalendar/trainingCalendarApiSlice';
import trainingHistorySlice from '../pages/trainingPage/trainingHistory/trainingHistorySlice';
import { trainingHistoryApi } from '../pages/trainingPage/trainingHistory/trainingHistoryApiSlice';
import dgReviewSlice from '../pages/academyPage/dgReview/dgReviewSlice'
import { dgReviewApi } from '../pages/academyPage/dgReview/dgReviewApiSlice';

const store = configureStore({
  reducer: {
    ...rootReducer,
    [galleryApi.reducerPath]: galleryApi.reducer,
    [magazineApi.reducerPath]: magazineApi.reducer,
    [eBookApi.reducerPath]: eBookApi.reducer,
    [visitUsApi.reducerPath]: visitUsApi.reducer,
    [knowledgePartnerApi.reducerPath]: knowledgePartnerApi.reducer,
    [dgReviewApi.reducerPath]: dgReviewApi.reducer,
    [homePageApi.reducerPath]: homePageApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [trainingCalendarApi.reducerPath]: trainingCalendarApi.reducer,
    [trainingHistoryApi.reducerPath]: trainingHistoryApi.reducer,
    gallery: gallerySlice,
    magazine: magazineSlice,
    eBook: eBookSlice,
    visitUs: visitUsSlice,
    knowledgePartner: knowledgePartnerSlice,
    dgReview: dgReviewSlice,
    homePage: homePageSlice,
    notification: notificationSlice,
    trainingCalendar: trainingCalendarSlice,
    trainingHistory: trainingHistorySlice,
    loaderBar: loaderSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      knowledgePartnerApi.middleware,
      dgReviewApi.middleware,
      notificationApi.middleware,
      homePageApi.middleware,
      galleryApi.middleware,
      magazineApi.middleware,
      eBookApi.middleware,
      visitUsApi.middleware,
      trainingCalendarApi.middleware,
      trainingHistoryApi.middleware,
      thunk),
  devTools: true,
});

export default store;
